import { SectionCard } from '@eogile/agrements-common/src/components/cards/SectionCard';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { FormMode, useFormMode } from '@eogile/agrements-common/src/form/helper/FormModeProvider';
import { FormGridItem } from '@eogile/agrements-common/src/components/grid/FormGridItem';
import { useIsLightDemandFormHelper } from '@eogile/agrements-common/src/demand/hooks/useIsLightDemandFormHelper';
import { EnumSelectAdapter } from '@eogile/agrements-common/src/form/components/EnumSelectAdapter';
import { pmuCandidateTypeLabels } from '../pmuDemandUtils';
import { Civility } from '@eogile/agrements-common/src/common-types/civilityTypes';
import { pmuCivilityLabels } from '../../utils/pmuLabelUtils';
import { DemandCandidateAddress } from '@eogile/agrements-common/src/demand/components/candidate/DemandCandidateAddress';
import { DemandCandidateContactFields } from '@eogile/agrements-common/src/demand/components/candidate/DemandCandidateContactFields';
import { DemandCandidateCommonIdentityFields } from '@eogile/agrements-common/src/demand/components/candidate/DemandCandidateCommonIdentityFields';
import { withFieldNamePrefix } from '@eogile/agrements-common/src/demand/demandFormUtils';
import { FormGridContainer } from '@eogile/agrements-common/src/components/grid/FormGridContainer';
import { FormGridContainersStack } from '@eogile/agrements-common/src/components/grid/FormGridContainersStack';
import { pmuCandidateTypesCompatibleWith } from '../pmuDemandFormUtils';
import { useAcquirerTypeFormValue } from '@eogile/agrements-common/src/demand/hooks/useAcquirerTypeFormValue';
import { useForm } from 'react-final-form';
import { PmuDemand } from '../pmuDemandTypes';
import { RequesterLinkedDemands } from '@eogile/agrements-common/src/demand/components/candidate/RequesterLinkedDemands';

type Props = {
  name: string;
  index: number;
  demand: PmuDemand | undefined;
};

export const PmuDemandCandidateSection = ({ name, index, demand }: Props) => {
  const { mutators } = useForm();
  const mode = useFormMode();
  const isLightDemand = useIsLightDemandFormHelper();
  const deletable = mode !== FormMode.READ && index > 0;
  const fieldName = withFieldNamePrefix(name);
  const acquirerType = useAcquirerTypeFormValue();

  return (
    <SectionCard
      dataTestId="candidate-section"
      title={`Candidat ${index + 1}`}
      headerAction={
        deletable ? (
          <IconButton onClick={() => mutators.remove('candidates', index)}>
            <Delete />
          </IconButton>
        ) : undefined
      }
    >
      <FormGridContainersStack>
        <FormGridContainer>
          {!isLightDemand && (
            <>
              <FormGridItem>
                <EnumSelectAdapter
                  label="Type"
                  name={fieldName('type')}
                  required
                  options={pmuCandidateTypesCompatibleWith(acquirerType)}
                  optionName={(opt) => pmuCandidateTypeLabels[opt]}
                />
              </FormGridItem>
              <FormGridItem>
                <EnumSelectAdapter
                  label="Civilité"
                  name={fieldName('civility')}
                  required
                  options={Object.values(Civility)}
                  optionName={(opt) => pmuCivilityLabels[opt]}
                />
              </FormGridItem>
            </>
          )}
          <DemandCandidateCommonIdentityFields name={name} />
        </FormGridContainer>
        {!isLightDemand && (
          <>
            <DemandCandidateAddress name={name} />
            <DemandCandidateContactFields name={name} />
          </>
        )}
      </FormGridContainersStack>
      {mode === FormMode.READ && (
        <RequesterLinkedDemands
          demandId={demand!.id}
          requesterIndex={index}
          requesterSearchCriteria={{
            firstName: demand!.candidates[index]?.firstNames,
            lastName: demand!.candidates[index]?.lastName,
            birthDate: demand!.candidates[index]?.birthDate,
          }}
        />
      )}
    </SectionCard>
  );
};
